import { SellCollectionNftMoleculeReatom } from "@/app/collections/instant-sell/use-collection-nfts-sell.reatom"
import { NftSelectionMoleculeReatom } from "@/app/nft/sell/selection/nft-selection-molecule.reatom"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo, useRef } from "react"
import { SolanaAcceptCollectionBidTransactionMoleculeReatom } from "./solana-accept-collection-bid-molecule.reatom"

export function useSolanaAcceptCollectionBid() {
  const { offerByNft } = useMolecule(SellCollectionNftMoleculeReatom)
  const { selectedNftsAtom } = useMolecule(NftSelectionMoleculeReatom)
  const selectedNfts = selectedNftsAtom()
  const { acceptCollectionBidActionFactory } = useMolecule(
    SolanaAcceptCollectionBidTransactionMoleculeReatom,
  )
  const acceptCollectionBidAction = useMemo(
    () => acceptCollectionBidActionFactory(),
    [acceptCollectionBidActionFactory],
  )
  const currentOfferByNft = offerByNft()

  const capturedDataRef = useRef<{
    selectedNfts: typeof selectedNfts
    offerByNft: typeof currentOfferByNft
  } | null>(null)

  const mutate = useCallback(() => {
    if (selectedNfts.length === 0) {
      return
    }

    capturedDataRef.current = {
      selectedNfts,
      offerByNft: currentOfferByNft,
    }

    void acceptCollectionBidAction({
      selectedNftsAtom,
      offerByNftAtom: offerByNft,
      blockchain: selectedNfts[0].collection.blockchain,
      capturedSelectedNfts: capturedDataRef.current.selectedNfts,
      capturedOfferByNft: capturedDataRef.current.offerByNft,
    })
  }, [
    acceptCollectionBidAction,
    currentOfferByNft,
    offerByNft,
    selectedNfts,
    selectedNftsAtom,
  ])

  return {
    mutate,
    acceptCollectionBidAction,
  }
}
